<script setup lang="ts">
import Checkbox from '../Checkbox/Checkbox.vue'
import Group from '../Group/Group.vue'

interface Props {
  options: string[]
  slotClass?: string
  disabled?: boolean
}

const props = defineProps<Props>()

// model
const selectedIndex = defineModel<number>()

// methods
function getOptionValue(option: number): string {
  return props.options[option - 1]
}

function selectIndex(index: number): void {
  selectedIndex.value = index
}
</script>

<template>
  <div
    v-if="options.length"
    class="flex gap-2"
  >
    <Group
      :optionsCount="options.length"
      :selectedOption="
        selectedIndex === undefined ? undefined : selectedIndex + 1
      "
    >
      <template #default="{ option, selected }">
        <Checkbox
          class="min-h-11 w-full min-w-26 rounded-sm border py-1 pl-2"
          :class="{
            'border-neutral-dark-0 bg-neutral-light-10': selected,
            'hover:bg-neutral-light-6': !selected && !disabled,
            'border-neutral-light-0 bg-neutral-light-8': !selected,
          }"
          :disabled
          :modelValue="selected"
          :variant="selected ? 'default' : 'neutral'"
          @update:modelValue="selectIndex(option - 1)"
        >
          <span>
            {{ getOptionValue(option) }}
          </span>
        </Checkbox>
      </template>
    </Group>
  </div>
</template>
